export default function (defaultState = false) {
    return {
        isActive: defaultState,
        toggle() {
            this.isActive = !this.isActive;
        },
        activate() {
            this.isActive = true;
        },
        deactivate() {
            this.isActive = false
        }
    }
}